import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Text, Tooltip, XAxis, YAxis } from 'recharts';
import { subsetData } from '../../utils/utils';




const CurrentStockChart = () => {
    const data = useSelector(state => state.rawData.value)
    const dateData = useSelector(state => state.dateData.value)
    const selectedItems = useSelector(state => state.chooseItem.value)

    const [chartData, setChartData] = useState({})
    const selectedDates = useSelector(state => state.chooseWeek.value)

    const chartFontStyle = {
        fontFamily: 'Roboto',
        fontWeight: 'bold'
    }
    
    // use effect that selects the data from the rawdata based on the selected items and sets the chartData
    
    useEffect(() => {
        if (data.keys != null){
            let temp = []
            Object.keys(selectedItems).forEach((ig) => {
                Object.keys(selectedItems[ig]).forEach((item) => {
                    if (selectedItems[ig][item] === true){
                        temp.push(subsetData(data, item, 'TARIEFOMSCHRIJVING'))
                    }
                })
            })
            let temp2 = []
            temp.forEach((item) => {
                item.forEach((item2) => {
                    temp2.push(item2)
                })
            })
            setChartData(temp2)
        }
    }, [data, selectedItems])


  return (
    <Box>
{/*         
        <LineChart width={400} height={400} data={data}>
            <Line type="monotone" dataKey="uv" stroke="#8884d8" />
        </LineChart> */}
        <ResponsiveContainer width="100%" aspect={5/2}>
            <BarChart 
                data={chartData}>
                <CartesianGrid strokeDasharray="2  10" />
                <XAxis 
                    dataKey="TARIEFOMSCHRIJVING" 
                    style={{...chartFontStyle, fontSize: '12px'}}
                    />
                <YAxis 
                    style={chartFontStyle}
                />
                <Tooltip />
                <Legend />
                <Text angle={180} textAnchor={'end'}/>
                <Bar dataKey="Inbestelling" fill="#FAF2A1" />
                <Bar dataKey="Inmateriaaluitgifte" fill="#759AAB" />
                <Bar dataKey="VRIJEVOORRAAD" fill="#453F78" />
            </BarChart>
        </ResponsiveContainer>

    </Box>
    )
}

export default CurrentStockChart